import * as tslib_1 from "tslib";
import * as undoActions from 'owa-mail-undo';
import getItemIdsFromConversations from 'owa-mail-list-store/lib/utils/getItemIdsFromConversations';
import scheduleItemsService from 'owa-mail-triage-action/lib/services/scheduleItemsService';
import { action } from 'satcheljs/lib/legacy';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import createItemContextsForDeleteStoreUpdate from 'owa-mail-triage-action/lib/actions/helpers/createItemContextsForDeleteStoreUpdate';
/**
 * Schedule or Unschedule items
 * @param rowKeys the row keys
 * @param tableView the tableView
 * @param actionSouce the actionSource
 * @param unschedule is this an unschedule request
 * @param scheduleReturnTime the time item will return
 */
export default action('scheduleItems' /* datapoints.scheduleItemsDatapoint */)(function scheduleItems(rowKeys, tableView, actionSource, unschedule, scheduleReturnTime) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var itemIdsToSchedule, itemContexts, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    undoActions.clearLastUndoableAction();
                    switch (tableView.tableQuery.listViewType) {
                        case 0 /* Conversation */:
                            itemIdsToSchedule = getItemIdsFromConversations(rowKeys, tableView.id);
                            break;
                        case 1 /* Message */:
                            itemIdsToSchedule = getRowIdsFromRowKeys(rowKeys, tableView.id);
                            break;
                    }
                    if (itemIdsToSchedule.length == 0) {
                        // No need to send out the service call
                        return [2 /*return*/, Promise.resolve()];
                    }
                    itemContexts = createItemContextsForDeleteStoreUpdate(itemIdsToSchedule);
                    deleteItemsStoreUpdate(itemContexts, tableView.tableQuery.folderId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, scheduleItemsService(itemIdsToSchedule, unschedule, scheduleReturnTime)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, Promise.resolve()];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(e_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=scheduleItems.js.map